import LoadingIndicator from '3-components/LoadingIndicator/LoadingIndicator';
import FieldHelper from '5-react-form-apps/FormElements/FieldHelper/FieldHelper';
import clsx from 'clsx';
import type { PropsWithChildren } from 'react';

interface FormFieldWrapperProps extends PropsWithChildren {
    id: string;
    label: string;
    description?: string;
    useLabel?: boolean;
    isOptional?: boolean;
    isError?: boolean;
    errorMessage?: string;
    className?: string;
    frequency?: string;
    isWarning?: boolean;
    warningMessage?: string;
    onInfoIconClick?: () => void;
}

const FormFieldWrapper = ({
    id,
    label,
    useLabel = true,
    isOptional = false,
    children,
    isError = false,
    errorMessage,
    className,
    description,
    frequency,
    isWarning = false,
    warningMessage,
    onInfoIconClick,
}: FormFieldWrapperProps): JSX.Element => {
    const labelElement = useLabel ? (
        <label htmlFor={id} className={`form-field-label ${onInfoIconClick ? 'form-field-label--with-icon' : ''}`} onClick={onInfoIconClick}>{label} {isOptional ? <span className="optional-label">(optional)</span> : <span className="required">*</span>}</label>
    ) : (
        <div className={`form-field-label ${onInfoIconClick ? 'form-field-label--with-icon' : ''}`} onClick={onInfoIconClick}>{label} {isOptional ? <span className="optional-label">(optional)</span> : <span className="required">*</span>}</div>
    );
    return (
        <div className={clsx('form-field-wrapper', className, { 'is-error': isError, 'is-warning': isWarning })}>
            <div className="form-field-label-group-wrapper">
                {label !== '' && (
                    labelElement
                )}
                {description && (
                    <div className="form-field-description">{description}</div>
                )}
                {frequency && (
                    <div className="form-field-sent-type">Sent: {frequency}</div>
                )}
            </div>
            <div className="box-input-field">
                {children}
            </div>
            {isError && errorMessage && (
                <FieldHelper
                    type="error"
                >
                    {errorMessage}
                </FieldHelper>
            )}

            {isWarning && warningMessage && (
                <FieldHelper
                    type="warning"
                >
                    {warningMessage}
                </FieldHelper>
            )}
        </div>
    );
};

const FormFieldLoading = (): JSX.Element => {
    return (
        <div
            className="form-field-loading"
            role="status"
            aria-live="polite"
            aria-label="Loading"
        >
            <LoadingIndicator />
        </div>
    );
};

FormFieldWrapper.Loading = FormFieldLoading;

export default FormFieldWrapper;
